import type { LabelValue } from '@ssml-editor/editor-vue';

export default <LabelValue[]>[
  {
    label: '公用',
    value: 'public',
  },
  {
    label: '我的',
    value: 'my',
  },
];
